import { IEvent } from "@Interfaces";
import { classNames } from "repoV2/utils/common/render/classNames";
import React from "react";
import commonStyles from "../commonStyles.module.scss";
import styles from "./upsellListings.module.scss";
import { useUpsellListings } from "./utils/useUpsellListings";
import UpsellListingCard from "./components/UpsellListingCard";

const UpsellListings = () => {
    const { sectionTitle, ...upsellListingProps } = useUpsellListings({});

    const { hideComponent, isLoading, upsellListings } = upsellListingProps;

    if (hideComponent) return null;

    // TODO: Filter out for slot availability
    return (
        <div className={commonStyles.detailsSection}>
            <div className={commonStyles.detailsSectionTitle}>
                {sectionTitle}
            </div>
            {isLoading ? (
                <div className={classNames("loader8", styles.loader)} />
            ) : (
                <div
                    className={classNames(
                        commonStyles.detailsSectionBody,
                        styles.root
                    )}
                >
                    <div className={styles.cardsContainer}>
                        {upsellListings.map((item: IEvent.IUpsellOffering) => (
                            <UpsellListingCard
                                item={item}
                                key={item.id}
                                {...upsellListingProps}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpsellListings;
